export default  {
  count (state) {
    return state.count
  },
  list (state) {
    return state.list
  },
  project (state) {
    return state.project
  },
   item: state => index => state.list.filter(e => e._id === index)[0]
}